import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (pathname !== "/" || !hash) return;
    const id = hash.replace("#", "");
    requestAnimationFrame(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: id === "hero-upload" ? "center" : "start",
        });
        return;
      }
      if (id === "top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    });
  }, [hash, pathname]);
}
